/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { SitePublishingAuth, SitePublishingAuthUpdate } from "./data-contracts";

/**
 * No description
 * @tags site-publishing-auth
 * @name GetSitePublishingAuthById
 * @summary Get a site auth config
 * @request GET:/orgs/{organizationId}/sites/{siteId}/publishing/auth
 * @secure
 */

// @ts-ignore
export const getSitePublishingAuthById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
  method: "get",
  streaming: false,
  tags: ["site-publishing-auth"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-publishing-auth
 * @name UpdateSitePublishingAuthById
 * @summary Update a site auth config
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/publishing/auth
 * @secure
 */

// @ts-ignore
export const updateSitePublishingAuthById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SitePublishingAuthUpdate;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth",
  method: "patch",
  streaming: false,
  tags: ["site-publishing-auth"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Regenerate the publishing authentication settings for a site. This will re-generate the private key.
 * @tags site-publishing-auth
 * @name RegenerateSitePublishingAuthById
 * @summary Regenerate a site auth
 * @request POST:/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate
 * @secure
 */

// @ts-ignore
export const regenerateSitePublishingAuthById: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishingAuth;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publishing/auth/regenerate",
  method: "post",
  streaming: false,
  tags: ["site-publishing-auth"],
  criticalityLevel: "low",
  deprecated: false,
};
